import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { Button } from 'antd';
import { PASTE_CHOICE_OPTIONS } from '../../shared/paste/pasteChoice';

export { PASTE_KEPT, PASTE_TEXT_ONLY } from '../../shared/paste/pasteChoice';

// Pastille affichée sous le texte après un collage mis en forme, dans le même
// portail que la barre flottante : hors de la box, elle n'est ni coupée ni
// recouverte par l'élément suivant. Le mousedown est bloqué : le clic ne doit
// ni ôter le focus à l'éditeur ni désélectionner la box. `content` : contenu
// courant, pour replacer la pastille quand la box change de taille.
const PasteChoice = ({ anchorRef, content, value, onChange }) => {
  const [position, setPosition] = useState(null);

  // useEffect et non useLayoutEffect : une ref posée par callback (cellule,
  // en-tête de tableau) est détachée puis rattachée à chaque rendu, après les
  // effets de layout des enfants ; elle vaudrait encore null ici.
  useEffect(() => {
    const place = () => {
      const rect = anchorRef.current?.getBoundingClientRect();
      if (!rect) return;
      setPosition((previous) => (
        previous?.top === rect.bottom && previous?.left === rect.right
          ? previous
          : { top: rect.bottom, left: rect.right }
      ));
    };
    place();
    // Défilement du canevas (capture : il ne remonte pas jusqu'à window).
    window.addEventListener('scroll', place, true);
    window.addEventListener('resize', place);
    return () => {
      window.removeEventListener('scroll', place, true);
      window.removeEventListener('resize', place);
    };
  }, [anchorRef, content]);

  const portal = document.getElementById('SelectionVariablePortal');
  if (!position || !portal) return null;

  return ReactDOM.createPortal(
    <div
      className="RichEditor-paste-choice"
      // Ni le container ni les menus ne la prennent pour un clic extérieur.
      data-outside-ignore="true"
      style={position}
      onMouseDown={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      {PASTE_CHOICE_OPTIONS.map((option) => (
        <Button
          key={option.value}
          size="small"
          type={option.value === value ? 'primary' : 'text'}
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </Button>
      ))}
    </div>,
    portal
  );
};

export default PasteChoice;
